import * as React from "react"
import UnderConstruction from "../components/under-construction"

const Index = () => {
  return (
        <UnderConstruction />
  )
};


export default Index

export const frontmatter = {
  title: "Under Construction"
};